'use strict';

import i18next from 'i18next';
import { api } from '../../utils/api-interceptor';

let servicesActivation = (() => {
  let lang = '';

  let init = (e) => llamarServicio(e);
  const llamarServicio = async (e) => {
    lang = e;
    const urlApi =
      `static_pages?slug=${i18next.t('routes.service_activation')}&temporal=` +
      Math.floor(Math.random() * 1000);

    try {
      const data = await api(urlApi, { hasLang: true });
      return data.content;
    } catch (error) {}
  };

  const getDataTable = async () => {
    let id;
    let data;
    if (i18next.t('routes.lng') === 'en') {
      id = 186;
    } else {
      id = 185;
    }
    const response = await api(`archives/${id}/download_json`);

    if (i18next.t('routes.lng') === 'en') {
      data = response.ServiceActivations;
    } else {
      data = response.ActivacionesDelServicio;
    }
    return data;
  };

  return {
    init: (e) => init(e),
    getData: (e) => getDataTable(e),
  };
})();

export { servicesActivation };
